<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"  ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="IssRegistViewInfo"
                        :filter_language="['order_status_name']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :row-class-name="tableRowClassName"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        :row-class-name="tableRowClassName"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_status_name" :label="$t('getapi[1861]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="delivery_order_no" :label="$t('getapi[1744]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="ipo_code" :label="$t('getapi[4283]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="receive_person" :label="$t('getapi[1745]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[1746]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3099]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_date" :label="$t('getapi[1210]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:840px;min-width:840px">
                    <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[463]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input v-model="dataDetail.Head.order_no" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[4283]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <routejump :urlNo="40" v-show="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.Head.ipo_code"
                                        type="text"
                                        readonly
                                        size="mini"
                                        class="mcolor"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpocode()"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.Head.ipo_code" v-show="addoredit != 1" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1744]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input v-model="dataDetail.Head.delivery_order_no" type="text" size="mini" v-show="addoredit == 1" class="mcolor"></el-input>
                                <el-input v-model="dataDetail.Head.delivery_order_no" type="text" size="mini" v-show="addoredit != 1" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1861]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input :value="expstatus(dataDetail.Head.order_status)" type="text" size="mini"
                                          :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[1745]') }}</td>
                            <td>
                                <routejump :urlNo="6" v-show="addoredit == 1">
                                <el-input
                                        v-model="dataDetail.Head.receive_person"
                                        type="text"
                                        readonly
                                        size="mini"
                                        class="mcolor"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee"></i>
                                </el-input>
                                </routejump>
                                <el-input v-model="dataDetail.Head.receive_person" v-show="addoredit != 1" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[1746]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.receive_time" type="date" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[410]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.create_person" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[135]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.create_date" type="date" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[733]') }}</td>
                            <td>
                                <el-input v-model="dataDetail.Head.modify_person" :readonly="true" class="readO"
                                          size="mini"></el-input>
                            </td>
                            <td>{{ $t('getapi[1210]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.modify_date" type="date" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[2205]') }}</td>
                            <td colspan="3">
                                <el-input v-model="dataDetail.Head.remark"
                                          size="mini"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 5px" @tab-click="selectInfo1">
                    <el-tab-pane :label="$t('getapi[1756]')" name="0">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="selectpartcode('')" :disabled="!btn.add_detail">{{ $t('getapi[6092]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="allCheck" :disabled="!btn.allcheck">{{
                                $t('getapi[1774]') }}
                            </el-button>
                            <el-button @click="lineCheck" type="primary" size="mini" :disabled="!btn.linecheck">{{$t('getapi[1775]')}}
                            </el-button>
                            <el-button @click="cLineCheck" type="primary" size="mini" :disabled="!btn.canclelincheck">
                                {{$t('getapi[1776]')}}
                            </el-button>
                            <el-button @click="check" type="primary" size="mini" :disabled="!btn.confirmycheck">{{$t('getapi[1777]')}}
                            </el-button>
                            <el-button @click="cCheck" type="primary" size="mini" :disabled="!btn.cancelecheck">{{$t('getapi[1778]')}}
                            </el-button>
                            <el-button @click="mrbCheck" type="primary" size="mini" :disabled="!btn.mrbcheck">{{$t('getapi[12627]') }}
                            </el-button>
                            <el-button @click="sayReturn" type="primary" size="mini" :disabled="!btn.sayreturn">{{$t('getapi[1779]')}}
                            </el-button>
                            <el-button @click="instruction" type="primary" size="mini" :disabled="!btn.instruction">
                                {{$t('getapi[6787]')}}
                            </el-button>
                            <el-button @click="auditLose" type="primary" size="mini" :disabled="!btn.lose">
                                {{$t('getapi[6788]')}}
                            </el-button>
                        </div>
                        <el-table
                                id="xdetilpane-0"
                                :data="dataDetail.Lists"
                                @selection-change="handleSelectionChange"
                                :highlight-current-row="true"
                                style="width: 100%; margin-top:3px"
                                :height="tableHeight - 160"
                                header-row-class-name="headerclass"
                                size="mini"
                                border
                                :header-cell-style="$limits.headerClass"
                                ref="singleTable1"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                             align="right" width="50">
                            </el-table-column>
                            <el-table-column prop="line_status_name"
                                             :label="$t('getapi[2325]')">
                                <template scope="scope">
                                    <span>{{ scope.row.line_status_name | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="ipo_line_no"
                                             :label="$t('getapi[4284]')"></el-table-column>
                            <el-table-column prop="part_code" :label="$t('getapi[226]')"
                                             width="120">
                                <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                    <el-input
                                            v-model="scope.row.part_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpartcode(scope)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version"
                                             :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_name"
                                             :label="$t('getapi[116]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="workproc_name"
                                             :label="$t('getapi[2510]')"></el-table-column>
                            <el-table-column prop="receive_qty" :label="$t('getapi[1617]')"
                                             align="right">
                                <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.receive_qty"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="lose_qty" :label="$t('getapi[6746]')"
                                             align="right">
                                <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                    <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.lose_qty"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="qualify_qty" :label="$t('getapi[1846]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="self_bad_qty" :label="$t('getapi[6758]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="vender_bad_qty" :label="$t('getapi[6789]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="scrap_qty" :label="$t('getapi[4220]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="return_qty" :label="$t('getapi[6790]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="inv_return_qty" :label="$t('getapi[6027]')" align="right"></el-table-column>
                            <el-table-column prop="check_flag" :label="$t('getapi[1308]')" sortable width="80">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.check_flag" :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="inv_unit" :label="$t('getapi[888]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="check_person" :label="$t('getapi[1770]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="check_date" :label="$t('getapi[1771]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="check_remark" :label="$t('getapi[1851]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="mrb_qty" :label="$t('getapi[12946]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="mrb_qualify_qty" :label="$t('getapi[12633]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="mrb_self_bad_qty" :label="$t('getapi[12937]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="mrb_vender_bad_qty" :label="$t('getapi[12938]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="mrb_scrap_qty" :label="$t('getapi[12939]')" align="right"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_remark" :label="$t('getapi[143]')"></el-table-column>
                            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="100">
                                <template slot-scope="scope">
                                    <el-popconfirm
                                            :confirmButtonText="$t('getapi[937]')"
                                            :cancelButtonText="$t('getapi[6]')"
                                            icon="el-icon-info"
                                            iconColor="red"
                                            :title="$t('getapi[637]')"
                                            @onConfirm="delline(scope)"
                                    >
                                        <el-button slot="reference" type="text" size="small" :disabled="!btn.rowdel">{{
                                            $t('getapi[40]') }}
                                        </el-button>
                                    </el-popconfirm>
                                    <el-button slot="reference" type="text" size="mini"
                                               @click.native.prevent="files(scope)">
                                        {{$t('getapi[3591]')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6421]')" name="1">
                        <div class="btnnowrap">
                            <el-upload :show-file-list="false" class="upload-demo"
                                       :data="fileparmH"
                                       :action="fileurlH"
                                       :on-change="handleChangeH"
                                       :on-success="handleSuccessH"
                                       :disabled="dataDetail.Head.order_no == ''">
                                <el-button size="mini" type="primary" :disabled="dataDetail.Head.order_no == ''">{{$t('getapi[3591]')}}</el-button>
                            </el-upload>
                        </div>
                        <el-table :data="FileListsH" :height="tableHeight - 160" size="mini" style="width: 100%; margin-top:3px"
                                 header-row-class-name="headerclass"
                                 border
                                 :header-cell-style="$limits.headerClass">
                            <el-table-column show-overflow-tooltip prop="Node_Name" :label="$t('getapi[3590]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[3605]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Doc_Size" :label="$t('getapi[7875]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Upload_Person" :label="$t('getapi[6425]')" width="150"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Upload_Time" :label="$t('getapi[6426]')" width="150"></el-table-column>
                            <el-table-column align="center" :label="$t('getapi[6048]')" width="100">
                                <template slot-scope="scope">
                                    <el-button slot="reference" type="text" size="small" @click.native.prevent="filedelH(scope)">{{$t('getapi[40]')}}
                                    </el-button>
                                    <el-button slot="reference" type="text" size="small" @click.native.prevent="openH(scope)">{{$t('getapi[3558]')}}
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="IssRegistViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1048]')" queryData="IssRegistViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--外协订单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/ISS/Regist/GePOCodePopupDataList'" @callback="getpocode" ref="pocode"></selector>
        <!-- 物料多选 -->
        <selector :isVisible="false" :isBatch=true :isSplitPage=true
                  :postUrl="'/ISS/Regist/GetPartCodePopupDataList'" @callback="getpartcode" ref="partcode"></selector>
        <!-- 物料单选 -->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/ISS/Regist/GetPartCodePopupDataList'" @callback="getpartcode" ref="partcodesingle"></selector>
        <!--人员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getemployee" ref="employee"></selector>
        <!--检验-->
        <el-dialog v-dialogDrag :visible.sync="isShowCheck" width="40%" :close-on-click-modal="false">
            <div style="margin-top: 20px">
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailCheck.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[149]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailCheck.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[4364]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailCheck.workproc_name" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1762]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.receive_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[1846]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.qualify_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[4220]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.scrap_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[6791]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.self_bad_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[6792]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.vender_bad_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[12628]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.mrb_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1841]') }}</td>
                        <td>
                            <el-date-picker v-model="dataDetailCheck.check_date" type="date" size="mini"
                                            style="width:100%"></el-date-picker>
                        </td>
                        <td>{{ $t('getapi[2064]') }}</td>
                        <td>
                            <el-input v-model="dataDetailCheck.check_person" type="text" size="mini" :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[1851]') }}</td>
                        <td colspan="3">
                            <el-input type="textarea" v-model="dataDetailCheck.check_remark" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowCheck = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmCheck">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!--MRB评审-->
        <el-dialog v-dialogDrag :visible.sync="isShowMRBCheck" width="40%" :close-on-click-modal="false">
            <div>
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailMRBCheck.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:100px">{{ $t('getapi[2510]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailMRBCheck.workproc_name" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:100px">{{ $t('getapi[149]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailMRBCheck.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[12946]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[12633]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_qualify_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[12937]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_self_bad_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[12938]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_vender_bad_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                        <td>{{ $t('getapi[12939]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_scrap_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[12642]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_check_date" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[12643]') }}</td>
                        <td>
                            <el-input v-model="dataDetailMRBCheck.mrb_check_person" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[12644]') }}</td>
                        <td colspan="3">
                            <el-input v-model="dataDetailMRBCheck.mrb_remark" type="textarea" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowMRBCheck = false">{{$t('getapi[2054]')}}</el-button>
				<el-button type="primary" @click="confirmMRBCheck">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!--退货-->
        <el-dialog v-dialogDrag :visible.sync="isShowReturn" width="40%" :close-on-click-modal="false">
            <div style="margin-top: 20px">
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[112]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailReturn.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[149]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailReturn.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[4364]') }}</td>
                        <td style="width:80px;">
                            <el-input v-model="dataDetailReturn.workproc_name" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[2086]') }}</td>
                        <td>
                            <el-input v-model="dataDetailReturn.wait_return_qty" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[1769]') }}</td>
                        <td>
                            <el-input v-model="dataDetailReturn.sum_return_qty" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>本次退货数</td>
                        <td>
                            <el-input v-model="dataDetailReturn.return_qty" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowReturn = false">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="debouncedConfirmReturn" :disabled="!btn.confirmreturn|| isSubmitting">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
        <!--上传-->
        <el-dialog v-dialogDrag :visible.sync="isVisiblefile" :title="$t('getapi[3591]')" width="50%">
            <el-upload :show-file-list="false" class="upload-demo"
                       :data="fileparm"
                       :action="fileurl"
                       :on-change="handleChange"
                       :on-success="handleSuccess">
                <el-button size="small" type="primary">{{$t('getapi[3591]')}}</el-button>
                <div slot="tip" class="el-upload__tip">{{$t('getapi[7961]')}}</div>
            </el-upload>
            <u-table :data="FileLists" border height="400" size="mini" style="width: 100%;"
                     :header-cell-style="$limits.headerClass">
                <el-table-column show-overflow-tooltip prop="Node_Name" :label="$t('getapi[3590]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Doc_Type" :label="$t('getapi[3605]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Doc_Size" :label="$t('getapi[7875]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Upload_Person" :label="$t('getapi[6425]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Upload_Time" :label="$t('getapi[6426]')" width="150"></el-table-column>
                <el-table-column fixed="right" align="center" :label="$t('getapi[6048]')">
                    <template slot-scope="scope">
                        <el-button slot="reference" type="text" size="small" @click.native.prevent="filedel(scope)">{{$t('getapi[40]')}}
                        </el-button>
                        <el-button slot="reference" type="text" size="small" @click.native.prevent="open(scope)">{{$t('getapi[3558]')}}
                        </el-button>
                    </template>
                </el-table-column>
            </u-table>
        </el-dialog>
        <!-- 不合格原因-->
        <!--<recreason :isVisible="recreasonVisible" @getrecreason="getrecreason" ref="recreason"></recreason>-->
        <selector :isVisible="recreasonVisible" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPurReasonDataList'" @callback="getrecreason" ref="recreason"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import { encryptDes, decryptDes,generatekey } from '@/utils/des.js';
    import debounce from 'lodash.debounce';
    export default {
        name: 'issueregistview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('issueregistview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                currentRow: null, // 当前选中行
                //isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    Head: {},
                    Lists: [],
                }, // 编辑页面数据详情
                oldDataDetail: '',
                code: '', // 当前
                selectData: [],
                dataChecked: [],
                rowindex: -1,
                isShowCheck: false,
                dataDetailCheck: [],
                isShowReturn: false,
                dataDetailReturn: [],
                recreasonVisible: false,
                addoredit: -1, // 1.新增2：编辑
                btn: {
                    //全部报检
                    allcheck: false,
                    //执行报检
                    linecheck: false,
                    //取消报检
                    canclelincheck: false,
                    ///执行检验
                    confirmycheck: false,
                    ///取消检验
                    cancelecheck: false,
                    //MRB评审
                    mrbcheck: false,
                    ///执行退货
                    sayreturn: false,
                    ///检验指导书
                    instruction: false,
                    //丢失审批
                    lose: false,
                    //明细行删除
                    rowdel: false,
                    //添加明细
                    add_detail: false,
                    //确认执行退货
                    confirmreturn: true,
                },
                dataDetailLineNo: 1,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                scrollTop:0,
                scrollTop1:0,
                isShowMRBCheck: false,
                dataDetailMRBCheck: {
                    part_code:'',
                    part_version:'',
                    workproc_name:'',
                    relation_order_no: '',
                    line_no: '',
                    mrb_qty: '',
                    mrb_self_bad_qty: '',
                    mrb_vender_bad_qty: '',
                    mrb_scrap_qty: '',
                    mrb_qualify_qty: '',
                    mrb_check_date: '',
                    mrb_check_person: '',
                    mrb_remark: '',
                },
                //上传（明细）
                isVisiblefile: false, //注意事项
                fileurl: '',
                fileparm: {
                    Code: '',
                    Data_Type: 30,
                    Login_Group:'',
                    Login_DB:'',
                },
                FileList: [],//注意事项文件
                FileLists: [], //注意事项文件
                //上传（单据）
                fileurlH: '',
                fileparmH: {
                    Code: '',
                    Data_Type: 31,
                    Login_Group:'',
                    Login_DB:'',
                },
                FileListH: [],//注意事项文件
                FileListsH: [], //注意事项文件
                isSubmitting:false,
            };
        },
        created: function () {
            let that = this;
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('issueregistview', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            let token = JSON.parse(that.userData).token;
            that.fileurl = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            that.fileurlH = Common.FileUrl+ '/Files/UpFileByDocManage?token=' + token;
            let parm = {
                PageIndex: 1,
                PageSize: 1000,
                Type: 0,
                Code: '',
                Name: '',
                Param: {}
            };
            that.$http.urlpost('/Basic/Popup/GetPurReasonDataList', parm, function (res) {
                if (res.Success == 1) {
                    that.arrreason = res.DataContent.DataList;
                }
            });
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'issrelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1033]"),this.$t("getapi[13]"));
            },
            tableRowClassName({row, rowIndex}) {
                if (row.Order_Status == '已检') {
                    return 'red';
                }
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('IssRegistViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 135, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 134, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 135, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 135, 1) == 2) {
                        if (that.$limits.authority('plv3', 135,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 135, 1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 135, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if (that.dataDetail.Head.order_status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }

                                if(that.dataDetail.Head.order_status == 0){
                                    that.$refs.SetBtn.SetOneBtnEnable('del',true);
                                }
                                else{
                                    that.$refs.SetBtn.SetOneBtnEnable('del',false);
                                }

                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                var rowNum = 0;
                var ISAllCheck = false;
                //全部报检
                that.btn.allcheck = false;
                //执行报检
                that.btn.linecheck = false;
                //取消报检
                that.btn.canclelincheck = false;
                //执行检验
                that.btn.confirmycheck = false;
                //取消检验
                that.btn.cancelecheck = false;
                //MRB检验
                that.btn.mrbcheck = false;
                //执行退货
                that.btn.sayreturn = false;
                //检验指导书
                that.btn.instruction = false;
                //丢失审批
                that.btn.lose = false
                //行删除
                that.btn.rowdel = false;
                that.btn.add_detail = false;

                if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                    //新建状态时，行不能操作，但是能删除行
                    that.btn.rowdel = true;
                    that.btn.add_detail = true;
                    that.btn.allcheck = false;
                    that.btn.linecheck = false;
                    that.btn.canclelincheck = false;
                    that.btn.confirmycheck = false;
                    that.btn.mrbcheck = false;
                    that.btn.cancelecheck = false;
                    that.btn.sayreturn = false;
                } else {
                    if(that.selectData.length == 0){
                        that.btn.linecheck = false;
                        that.btn.confirmycheck = false;
                        if(that.dataDetail.Head.order_status == 0){
                            that.btn.add_detail = true;
                            that.btn.rowdel = true;
                        }
                        that.btn.allcheck = true;
                        for(let i = 0 ;i< that.dataDetail.Lists.length;i++){
                            if(that.dataDetail.Lists[i].line_status != 0){
                                that.btn.allcheck = false;
                            }
                        }
                    } else if(that.selectData.length == 1){
                        if(that.dataDetail.Head.order_status == 0){
                            that.btn.add_detail = true;
                            that.btn.rowdel = true;
                        }
                        for(let i = 0;i<that.selectData.length;i++){
                            if(that.selectData[i].exclusively_id == '' || that.selectData[i].exclusively_id == 0){
                                that.btn.allcheck = false;
                                that.btn.linecheck = false;
                                that.btn.canclelincheck = false;
                                that.btn.cancelecheck = false;
                                that.btn.cancelecheck = false;
                                that.btn.sayreturn = false;
                                return
                            }
                        }
                        if(that.selectData[0].line_status == 0){
                            that.btn.rowdel = true;
                            that.btn.add_detail = true;
                            let IsLoseType = false
                            for(let i = 0;i<that.selectData.length;i++){
                                if(that.selectData[i].lose_qty > 0){
                                    IsLoseType = true
                                    break
                                }
                            }
                            if(IsLoseType){
                                if((that.$limits.authority('plv4', 90, 1) != 0)){
                                    that.btn.lose = true
                                } else {
                                    that.btn.lose = false
                                }
                            } else {
                                that.btn.allcheck = true;
                                that.btn.linecheck = true;
                            }
                            that.btn.canclelincheck = false;
                            that.btn.confirmycheck = false;
                            that.btn.cancelecheck = false;
                            that.btn.sayreturn = false;
                        } else if (that.selectData[0].line_status == 1){
                            that.btn.rowdel = false;
                            that.btn.add_detail = false;
                            that.btn.allcheck = false;
                            that.btn.linecheck = false;
                            that.btn.canclelincheck = true;
                            if(that.$limits.authority('plv4', 112, 1) != 0){
                                that.btn.confirmycheck = true;
                            } else {
                                that.btn.confirmycheck = false
                            }
                            that.btn.cancelecheck = false;
                            that.btn.sayreturn = false;
                            that.btn.instruction = true;
                        } else if (that.selectData[0].line_status == 2){
                            that.btn.rowdel = false;
                            that.btn.add_detail = false;
                            that.btn.allcheck = false;
                            that.btn.linecheck = false;
                            that.btn.canclelincheck = false;
                            that.btn.confirmycheck = false;
                            if(that.$limits.authority('plv4', 113, 1) != 0){
                                that.btn.cancelecheck = true;
                            } else {
                                that.btn.cancelecheck = false;
                            }
                            that.btn.sayreturn = true;
                        } else if (that.selectData[0].line_status == 3){
                            that.btn.rowdel = false;
                            that.btn.add_detail = false;
                            that.btn.allcheck = false;
                            that.btn.linecheck = false;
                            that.btn.canclelincheck = false;
                            that.btn.confirmycheck = false;
                            that.btn.cancelecheck = false;
                            that.btn.sayreturn = true;
                        } else if (that.selectData[0].line_status == 4) { //MRB评审
                            if (parseFloat(that.selectData[0].mrb_qty) >= 0) {
                                if (that.$limits.authority('plv4', 230, 1) == 1){
                                    that.btn.mrbcheck = true;
                                } else {
                                    that.btn.mrbcheck = false;
                                }
                            }
                        }
                    } else {
                        if(that.dataDetail.Head.order_status == 0){
                            that.btn.add_detail = true;
                            that.btn.rowdel = true;
                        }
                        //全部报检
                        that.btn.allcheck = true;
                        //执行报检
                        that.btn.linecheck = false;
                        //取消报检
                        that.btn.canclelincheck = false;
                        //执行检验
                        that.btn.confirmycheck = false;
                        //取消检验
                        that.btn.cancelecheck = false;
                        //执行退货
                        that.btn.sayreturn = false;
                        //检验指导书
                        that.btn.instruction = false;
                        //丢失审批
                        that.btn.lose = false
                        for(let i = 0 ;i< that.selectData.length;i++){
                            if(that.selectData[i].line_status != 0){
                                that.btn.allcheck = false;
                            }
                        }
                    }

                }
                //执行检验 LV3 112
                if (that.btn.confirmycheck == true) {
                    that.btn.confirmycheck = (that.$limits.authority('plv4', 112, 1) != 0)
                }
                //取消检验  LV3 113
                if (that.btn.cancelecheck == true) {
                    that.btn.cancelecheck = (that.$limits.authority('plv4', 113, 1) != 0)
                }
                //丢失审批 90
                if (that.btn.lose == true) {
                    that.btn.lose = (that.$limits.authority('plv4', 90, 1) != 0)
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('issueregistview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                console.log('val' + val)
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'IssRegistViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/ISS/Regist/IssRegistViewList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 135, 1)){
                        return
                    }
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no;
                                that.getDetail(row.order_no);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no;
                        that.getDetail(row.order_no);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(order_no) {
                let that = this;
                that.addoredit = 2;
                that.selectData = [];
                that.dataChecked = [];
                let parm = {
                    Code: order_no
                };
                that.FileList = [];
                that.FileLists = [];
                that.FileListH = [];
                that.FileListsH = [];
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/ISS/Regist/GetIssRegistBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.FileList = res.DataContent.Attrs;
                        if(that.FileList){
                            that.FileList.forEach(item => {
                                if (item.Code == that.fileparm.Code) {
                                    that.FileLists.push(item);
                                }
                            })
                        }
                        that.FileListH = res.DataContent.fileLists;
                        if(that.FileListH){
                            that.FileListH.forEach(item => {
                                if (item.Code == that.dataDetail.Head.order_no) {
                                    that.FileListsH.push(item);
                                }
                            })
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority();
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let date = Common.methods.getDate();
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        order_no: '',
                        delivery_order_no: '',
                        ipo_code: '',
                        order_status: 0,
                        receive_person: '',
                        receive_time: date,
                        remark: '',
                        create_person: '',
                        create_date: '',
                        modify_person: '',
                        modify_date: '',
                        concurrent_time: ''
                    },
                    Lists: [],
                };
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
               /* let that = this;
                that.getView();
                if (that.addoredit != 1) {
                    that.getDetail(that.order_no)
                } else {
                    that.add()
                }*/
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 1){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 1){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Regist/IssRegistViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "IssRegistViewInfo",
                    fromname: that.$t('getapi[1048]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let arr = []
                for(let i = 0;i<that.dataDetail.Lists.length;i++){
                    arr = [...arr, that.dataDetail.Lists[i].line_no]
                }
                if(that.$limits.isRepeat(arr)){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    let parm = that.dataDetail;
                    parm.LangType = that.$processdata.getLang()
                    that.$http.urlpost('/ISS/Regist/IssRegistSaveData', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            let parm = res.UniqueNum;
                            that.code = parm;
                            that.getDetail(parm);
                        }
                    });
                } else {
                    that.$message.warning(that.$t('getapi[2124]'));//行号不能重复
                }
            },
            //获取采购订单
            selectpocode() {
                let that = this;
                that.$refs.pocode.clearInput(true);
            },
            // 获取订单信息
            getpocode(data) {
                let that = this;
                console.log(data)
                let datetime = Common.methods.getDatetime()
                let date = Common.methods.getDate()
                that.dataDetail.Head.ipo_code = data.ipo_code
                that.dataDetail.Head.receive_time = date
            },
            // 新增物料
            selectpartcode(row) {
                let that = this;
                if(that.dataDetail.Head.ipo_code == '' || that.dataDetail.Head.ipo_code == null){
                    that.$message.warning(that.$t('getapi[8835]'));//'外协订单号不能为空'
                    return
                }
                if (row == '') {
                    that.oneormore = 1;
                    let param = {
                        order_no: that.dataDetail.Head.order_no,
                        ipo_code: that.dataDetail.Head.ipo_code
                    }
                    that.$refs.partcode.clearInput(true, param);
                } else {
                    that.oneormore = 2;
                    this.rowindex = row.$index;
                    let param = {
                        order_no: that.dataDetail.Head.order_no,
                        ipo_code: that.dataDetail.Head.ipo_code
                    }
                    that.$refs.partcodesingle.clearInput(true, param);
                }
            },
            // 获取物料信息
            getpartcode(data) {
                let that = this;
                console.log(data);
                console.log(that.dataDetail.Lists)
                let arr = data.filter(item => {
                    return that.dataDetail.Lists.every(item2 => {
                        return item.line_no != item2.ipo_line_no;
                    });
                });
                data = arr;
                if (that.oneormore == 1) {
                    that.dataDetailLineNo = 1
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].line_no >= that.dataDetailLineNo) {
                            that.dataDetailLineNo = that.dataDetail.Lists[i].line_no + 1
                        }
                    }
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.Lists = [
                            ...that.dataDetail.Lists,
                            {
                                exclusively_id:'',
                                relation_order_no:'',
                                ipo_line_id:data[i].exclusively_id,
                                ipo_line_no:data[i].line_no,
                                line_no:that.dataDetailLineNo++,
                                part_code:data[i].part_code,
                                part_name:data[i].part_name,
                                part_version:data[i].part_version,
                                workproc_name:data[i].routing_direction,
                                receive_qty:data[i].receive_qty,
                                qualify_qty:0,
                                self_bad_qty:0,
                                vender_bad_qty:0,
                                scrap_qty:0,
                                return_qty:0,
                                inv_unit:data[i].measure_unit,
                                line_status:'',
                                line_status_name:data[i].line_status,
                                check_person:'',
                                check_date:'',
                                check_remark:'',
                                batch_no:'',
                                sequence_no:'',
                                line_remark:'',
                                inv_receive_qty:0,
                                inv_receive_scrap_qty:0,
                                inv_receive_self_bad_qty:0,
                                inv_return_qty:0,
                                lose_qty:0,
                                fa_flag:data[i].fa_flag,
                                so_code:data[i].so_code,
                                check_flag:data[i].check_flag
                            }
                        ];
                    }
                } else {
                    if (this.rowindex < this.dataDetail.Lists.length && this.rowindex != -1) {
                        that.dataDetail.Lists[that.rowindex].exclusively_id ='',
                        that.dataDetail.Lists[that.rowindex].relation_order_no ='',
                        that.dataDetail.Lists[that.rowindex].ipo_line_id =data.exclusively_id,
                        that.dataDetail.Lists[that.rowindex].ipo_line_no =data.line_no,
                        that.dataDetail.Lists[that.rowindex].part_code =data.part_code,
                        that.dataDetail.Lists[that.rowindex].part_name =data.part_name,
                        that.dataDetail.Lists[that.rowindex].part_version =data.part_version,
                        that.dataDetail.Lists[that.rowindex].workproc_name =data.routing_direction,
                        that.dataDetail.Lists[that.rowindex].receive_qty =data.receive_qty,
                        that.dataDetail.Lists[that.rowindex].qualify_qty =0,
                        that.dataDetail.Lists[that.rowindex].self_bad_qty =0,
                        that.dataDetail.Lists[that.rowindex].vender_bad_qty =0,
                        that.dataDetail.Lists[that.rowindex].scrap_qty =0,
                        that.dataDetail.Lists[that.rowindex].return_qty =0,
                        that.dataDetail.Lists[that.rowindex].inv_unit =data.measure_unit,
                        that.dataDetail.Lists[that.rowindex].line_status ='',
                        that.dataDetail.Lists[that.rowindex].line_status_name =data.line_status,
                        that.dataDetail.Lists[that.rowindex].check_person ='',
                        that.dataDetail.Lists[that.rowindex].check_date ='',
                        that.dataDetail.Lists[that.rowindex].check_remark ='',
                        that.dataDetail.Lists[that.rowindex].batch_no ='',
                        that.dataDetail.Lists[that.rowindex].sequence_no ='',
                        that.dataDetail.Lists[that.rowindex].line_remark ='',
                        that.dataDetail.Lists[that.rowindex].inv_receive_qty =0,
                        that.dataDetail.Lists[that.rowindex].inv_receive_scrap_qty =0,
                        that.dataDetail.Lists[that.rowindex].inv_receive_self_bad_qty =0,
                        that.dataDetail.Lists[that.rowindex].inv_return_qty =0,
                        that.dataDetail.Lists[that.rowindex].lose_qty =0,
                        that.dataDetail.Lists[that.rowindex].fa_flag =data.fa_flag,
                        that.dataDetail.Lists[that.rowindex].so_code =data.so_code,
                        that.dataDetail.Lists[that.rowindex].check_flag =data.check_flag
                        
                    } else {
                        that.dataDetail.Lists = [
                            ...that.dataDetail.Lists,
                            {
                                exclusively_id:'',
                                relation_order_no:'',
                                ipo_line_id:data.exclusively_id,
                                ipo_line_no:data.line_no,
                                line_no:that.dataDetailLineNo++,
                                part_code:data.part_code,
                                part_name:data.part_name,
                                part_version:data.part_version,
                                workproc_name:data.routing_direction,
                                receive_qty:data.receive_qty,
                                qualify_qty:0,
                                self_bad_qty:0,
                                vender_bad_qty:0,
                                scrap_qty:0,
                                return_qty:0,
                                inv_unit:data.measure_unit,
                                line_status:'',
                                line_status_name:data.line_status,
                                check_person:'',
                                check_date:'',
                                check_remark:'',
                                batch_no:'',
                                sequence_no:'',
                                line_remark:'',
                                inv_receive_qty:0,
                                inv_receive_scrap_qty:0,
                                inv_receive_self_bad_qty:0,
                                inv_return_qty:0,
                                lose_qty:0,
                                fa_flag:data.fa_flag,
                                so_code:data.so_code,
                                check_flag:data.check_flag
                            }
                        ];
                    }
                }
            },
            selectemployee(type) {
                let that = this;
                that.$refs.employee.clearInput(true);
            },
            getemployee(data) {
                let that = this;
                that.dataDetail.Head.receive_person = data.name;
            },
            expstatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[1803]')//'待检';
                } else if (val == 2) {
                    return that.$t('getapi[1749]')//'已检';
                } else if (val == 3) {
                    return that.$t('getapi[441]')//'关闭';
                } else if (val == 4) {
                    return that.$t('getapi[12627]')//'MRB评审';
                } else {
                    return '';
                }
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                that.dataChecked = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                for (let i = 0; i < val.length; i++) {
                    that.dataChecked.push(val[i].exclusively_id);
                }
                that.btnauthority();
            },
            allCheck() {
                let that = this;
                for(let i = 0 ;i< that.dataDetail.Lists.length;i++){
                    if(that.dataDetail.Lists[i].line_status == 0 && that.dataDetail.Lists[i].lose_qty>0){
                        that.$message.warning(that.$t('getapi[1425]')+that.dataDetail.Lists[i].line_no+that.$t('getapi[12335]'));//只支持单行删除,请重新勾选
                        return;
                    }
                }
                let parm = {
                    Code : that.dataDetail.Head.order_no
                };
                that.btn.allcheck = false
                that.$http.urlpost('/ISS/Regist/AllCheckReport', parm, function (res) {
                    that.btn.allcheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                });
            },
            delline(data) {
                let that = this;
                console.log(data)
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[8756]'));//只支持单行删除,请重新勾选
                    return;
                }
                that.dataDetail.Lists.splice(data.$index, 1);
                if (data.row.exclusively_id != '') {
                    let parm = {
                        order_no: that.dataDetail.Head.order_no,
                        ipo_code: that.dataDetail.Head.ipo_code,
                        concurrent_time: that.dataDetail.Head.concurrent_time,
                        line_no: data.row.line_no
                    };
                    that.$http.urlpost('/ISS/Regist/DelIssRegistLine', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.getDetail(that.code)
                        }
                    });
                }
            },
            lineCheck() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[8756]'));//'不支持多行执行报检,请重新勾选'
                    return;
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    line_no: that.selectData[0].line_no,
                    check_flag: that.selectData[0].check_flag,
                };
                that.btn.linecheck = false
                that.$http.urlpost('/ISS/Regist/ExecuteCheckReport', parm, function (res) {
                    that.btn.linecheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                });
            },
            cLineCheck() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[8756]'));//'不支持多行取消报检,请重新勾选'
                    return;
                }

                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    line_no: that.selectData[0].line_no
                };
                that.btn.canclelincheck = false
                that.$http.urlpost('/ISS/Regist/UnCheckReport', parm, function (res) {
                    that.btn.canclelincheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                });
            },
            check() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[8756]'));//'不支持多行执行检验,请重新勾选'
                    return;
                }
                let date = Common.methods.getDate()
                that.dataDetailCheck = {
                    order_no: that.dataDetail.Head.order_no,
                    ipo_code: that.dataDetail.Head.ipo_code,
                    line_no: that.selectData[0].line_no,
                    part_code: that.selectData[0].part_code,
                    part_version: that.selectData[0].part_version,
                    workproc_name: that.selectData[0].workproc_name,
                    receive_qty: that.selectData[0].receive_qty,
                    qualify_qty: that.selectData[0].qualify_qty,
                    self_bad_qty: that.selectData[0].self_bad_qty,
                    vender_bad_qty: that.selectData[0].vender_bad_qty,
                    scrap_qty: that.selectData[0].scrap_qty,
                    return_qty: that.selectData[0].return_qty,
                    check_remark: that.selectData[0].check_remark,
                    check_person: that.user,
                    check_date: date,
                    mrb_qty:that.selectData[0].mrb_qty,
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    ipo_code: that.dataDetail.Head.ipo_code,
                    part_code: that.selectData[0].part_code,
                    part_version: that.selectData[0].part_version,
                    workproc_name: that.selectData[0].workproc_name
                }
                that.btn.confirmycheck = false
                that.$http.urlpost('/ISS/Regist/IsFaCheck', parm, function (res) {
                    that.btn.confirmycheck = true
                    if (res.Success == 1) {
                        that.isShowCheck = true;
                    } else if(res.Success == 2){
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.isShowCheck = true;
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });

            },
            confirmCheck() {
                let that = this;
                if(that.dataDetailCheck.receive_qty != (parseFloat(that.dataDetailCheck.qualify_qty) + parseFloat(that.dataDetailCheck.scrap_qty) + parseFloat(that.dataDetailCheck.self_bad_qty) + parseFloat(that.dataDetailCheck.vender_bad_qty) + parseFloat(that.dataDetailCheck.mrb_qty))){
                    that.$message.error(that.$t('getapi[12947]'));//'合格数+报废数+己方不良数+供方不良数必须等于待检数！'
                    return
                }
                let parm = that.dataDetailCheck
                that.btn.confirmycheck = false
                that.$http.urlpost('/ISS/Regist/ExecuteCheck', parm, function (res) {
                    that.btn.confirmycheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowCheck = false;
                        that.getDetail(that.code)
                    }
                });
            },
            cCheck() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[8756]'));//'不支持多行取消检验,请重新勾选'
                    return;
                }
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    line_no: that.selectData[0].line_no,
                };
                that.btn.cancelecheck = false
                that.$http.urlpost('/ISS/Regist/ExecuteUnCheck', parm, function (res) {
                    that.btn.cancelecheck = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                });
            },
            sayReturn() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[8756]'));//'不支持多行执行退货,请重新勾选'
                    return;
                }
                let parm1 = {
                    order_no: that.dataDetail.Head.order_no,
                    line_no: that.selectData[0].line_no,
                    part_code: that.selectData[0].part_code,
                    part_version: that.selectData[0].part_version,
                    workproc_name: that.selectData[0].workproc_name,
                    wait_return_qty: '',
                    return_qty: ''
                }
                that.$http.urlpost('/ISS/Regist/IsCheckReturn', parm1, function (res) {
                    if (res.Success == 1) {
                        that.isShowReturn = true;
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            line_no: that.selectData[0].line_no,
                            LangType: that.$processdata.getLang(),
                        };
                        that.btn.sayreturn = false
                        that.$http.urlpost('/ISS/Regist/GetReturnQty', parm, function (res) {
                            that.btn.sayreturn = true
                            if (res.Success == 1) {
                                console.log(1)
                                let data = res.DataContent
                                that.dataDetailReturn = {
                                    order_no: that.dataDetail.Head.order_no,
                                    line_no: that.selectData[0].line_no,
                                    part_code: that.selectData[0].part_code,
                                    part_name: that.selectData[0].part_name,
                                    part_version: that.selectData[0].part_version,
                                    workproc_name: that.selectData[0].workproc_name,
                                    wait_return_qty: data.wait_return_qty,
                                    sum_return_qty: data.sum_return_qty,
                                    return_qty: '',
                                }
                            }
                        });
                    }
                });
            },
             // 防抖处理，500ms内只能触发一次
            debouncedConfirmReturn: debounce(function() {
                this.confirmReturn();
            }, 500, { 
                leading: true, 
                trailing: false 
            }),
            confirmReturn() {
                let that = this;   
                if (that.isSubmitting) return; // 防止重复点击
                that.isSubmitting = true;             
                if(!that.btn.confirmreturn){
                    return false
                }
                that.btn.confirmreturn = false
                let parm = {
                    order_no: that.dataDetailReturn.order_no,
                    line_no: that.dataDetailReturn.line_no,
                    part_code: that.dataDetailReturn.part_code,
                    part_name: that.dataDetailReturn.part_name,
                    part_version: that.dataDetailReturn.part_version,
                    workproc_name: that.dataDetailReturn.workproc_name,
                    wait_return_qty: that.dataDetailReturn.wait_return_qty,
                    return_qty: parseFloat(that.dataDetailReturn.return_qty),
                };
                
                that.$http.urlpost('/ISS/Regist/ExecuteReturn', parm, function (res) {
                    that.btn.confirmreturn = true
                    that.isSubmitting = false;
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowReturn = false;
                        that.getDetail(that.code);
                    }
                });
            },
            auditLose(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    line_no: that.selectData[0].line_no
                };
                that.btn.lose = false
                that.$http.urlpost('/ISS/Regist/AuditLose', parm, function (res) {
                    that.btn.lose = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                });
            },
            instruction() {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[8756]'));//'不支持多行检验指导书,请重新勾选'
                    return;
                }
                let parm = {
                    part_code: that.selectData[0].part_code,
                    LangType: that.$processdata.getLang(),
                };
                that.btn.instruction = false
                that.$http.urlpost('/ISS/Regist/Instruction', parm, function (res) {
                    that.btn.instruction = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                });
            },
            selectrejectreason() {
                let that = this;
                that.recreasonVisible = true;
                let param = {
                    po_code: ''
                }
                that.$refs.recreason.clearInput(this.recreasonVisible, param);
            },
            getrecreason(data) {
                let that = this;
                console.log(data);
                that.dataDetailCheck.reject_reason_id = data.num;
            },
            expReason(val) {
                let that = this;
                let res = '';
                for (let i = 0; i < that.arrreason.length; i++) {
                    if (that.arrreason[i].num == val) {
                        res = that.arrreason[i].description;
                        break;
                    }
                }
                return res;
            },
            // 执行退货获取合格和不合格数量
            getReturnNum() {
                let that = this
                if (that.dataDetailCheck.alreadyreturn_qty > that.dataDetailReturn.ought_return_qty) {
                    return
                }
            },
            
            //单据删除
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            ipo_code: that.dataDetail.Head.ipo_code,
                            concurrent_time: that.dataDetail.Head.concurrent_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/ISS/Regist/DelIssRegistBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            mrbCheck(data) {
                let that = this;
                if (that.selectData.length > 1) {
                    that.$message.warning(that.$t('getapi[4229]'));
                    return;
                }
                that.isShowMRBCheck = true;
                that.dataDetailMRBCheck.part_code = that.selectData[0].part_code
                that.dataDetailMRBCheck.part_version = that.selectData[0].part_version
                that.dataDetailMRBCheck.workproc_name = that.selectData[0].workproc_name
                that.dataDetailMRBCheck.relation_order_no = that.selectData[0].relation_order_no
                that.dataDetailMRBCheck.line_no = that.selectData[0].line_no
                that.dataDetailMRBCheck.mrb_qty = that.selectData[0].mrb_qty
                that.dataDetailMRBCheck.mrb_self_bad_qty = that.selectData[0].mrb_self_bad_qty
                that.dataDetailMRBCheck.mrb_vender_bad_qty = that.selectData[0].mrb_vender_bad_qty
                that.dataDetailMRBCheck.mrb_scrap_qty = that.selectData[0].mrb_scrap_qty
                that.dataDetailMRBCheck.mrb_qualify_qty = that.selectData[0].mrb_qualify_qty
                that.dataDetailMRBCheck.mrb_check_date = that.selectData[0].mrb_check_date
                that.dataDetailMRBCheck.mrb_check_person = that.user
                that.dataDetailMRBCheck.mrb_remark = that.selectData[0].mrb_remark
            },
            confirmMRBCheck() {
                let that = this;
                let date = Common.methods.getDatetime();
                that.dataDetailMRBCheck.mrb_check_date = date;
                let parm =  that.dataDetailMRBCheck
                that.$http.urlpost('/ISS/Regist/IssReceiveMrbConfirm', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowMRBCheck = false;
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                });
            },
            // 上传
            files(e) {
                let that = this;
                this.FileLists = [];
                this.fileparm.Code = e.row.exclusively_id;
                this.FileList.forEach(item => {
                    if (item.Code == e.row.exclusively_id) {
                        this.FileLists.push(item);
                    }
                })
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparm.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparm.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
                this.isVisiblefile = true;
            },
            handleChange(file, fileList) {
                this.FileList = fileList.slice(-3);
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.getDetail(that.code);
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
            },
            //删除文件
            filedel(row) {
                let that = this;
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.getDetail(that.code);
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //打开文件
            open(row) {
                let that = this;
                // if (!that.$limits.fnIsEmpty(row.row.path)) {
                //     window.open(Common.Url + row.row.path);
                // }
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                console.log(parm);
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            // 上传(单据)
            filesH(e) {
                let that = this;
                this.FileListsH = [];
                this.fileparmH.Code = that.dataDetail.Head.order_no;
                this.FileListH.forEach(item => {
                    if (item.Code == that.dataDetail.Head.order_no) {
                        this.FileListsH.push(item);
                    }
                })
                that.userData = sessionStorage.getItem('userData');
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.fileparmH.Login_Group=encryptDes(JSON.parse(that.userData).Login_Group,key);
                that.fileparmH.Login_DB=encryptDes(JSON.parse(that.userData).Login_DB,key);
            },
            handleChangeH(file, fileList) {
                this.filesH()
                this.FileListH = fileList.slice(-3);
            },
            handleSuccessH(res, file, fileList) {
                let that = this;
                console.log('------handleSuccess---', res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.getDetail(that.code);
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                }
            },
            //删除文件
            filedelH(row) {
                let that = this;
                that.$confirm(that.$t('getapi[8599]'), that.$t('getapi[194]'), {//此操作将永久删除该文件, 是否继续?
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let src = typeof row.row.FileSrc == 'undefined' ? '' : row.row.FileSrc;
                        let parm = {
                            ids: row.row.Node_ID,
                            FilesSrc: src
                        };
                        that.$http.urlpost('/Basic/DeleteFileByDocManageID', parm, res => {
                            if (res.Success == 1) {
                                that.getDetail(that.code);
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            //打开文件
            openH(row) {
                let that = this;
                const key = generatekey(8); // 也可直接指定key let key = 'des';
                that.loading = true;
                that.userData = sessionStorage.getItem('userData');
                let parm = {
                    Login_Group: encryptDes(JSON.parse(that.userData).Login_Group,key),
                    Login_DB: encryptDes(JSON.parse(that.userData).Login_DB,key),
                    CType:row.row.ConfigType,
                    OthInfo:'',
                    NodeId:row.row.Node_ID,
                };
                that.$http.urlfilepost(row.row.HttpPost,'/Files/GetFileUrl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl =res.DataContent;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 135,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }
</style>
